module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/pictures-1-7c2afc1ee4a20e1fa3b72696a0f53781.svg";